<template>
    <div class="or-admin-header flex-row row-ver-center">
        <div class="title flex-row flex-center">
            <p class="text">Панель Администратора</p>
        </div>
        <div class="content flex-row row-space-between row-ver-center">
            <img class="logo" src="../../../assets/logo-white.jpg"/>
            <p class="button hover-pointer hover-yellow" v-if="$parent.auth === true" @click="$emit('logout')">Выйти</p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
    .or-admin-header {
        position: relative;
        margin: 0 auto;
        width: 1200px;
        height: 60px;
        border-bottom: #EBEFF2 2px solid;
        filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
        box-sizing: border-box;
    }
    .title {
        width: 256px;
        height: 100%;
        background-color: #1e1e1e;
        color: white;
    }
    .text {
        font-size: 14px;
        line-height: 16px;
        font-weight: bold;
    }
    .content {
        width: 944px;
        height: 100%;
        background-color: #ffffff;
        color: black;
    }
    .logo {
        height: 35px;
        margin-left: 40px
    }
    .button {
        font-size: 14px;
        line-height: 16px;
        margin-right: 40px
    }
</style>